import keyMirror from 'keymirror'

export default keyMirror({
  INVITES_ADDED: null,
  DESTROYED: null,
}, 'SURVEY_SUBMISSION');
